import datePicker from './datePicker';
import location from './location';
import collapsableLinkList from './collapsableLinkList';
import results from './results';
import noResults from './noResults';

export default (config) => ({
  datePicker: datePicker(config),
  location: location(config),
  collapsableLinkList,
  results,
  noResults,
  isLoading(state) {
    return state.isLoading;
  },
});
